import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import LandingPage from './pages/LandingPage';
import UploadFlow from './pages/UploadFlow';
import Dashboard from './pages/Dashboard';
import AdminDashboard from './pages/AdminDashboard';
import ResultsDemo from './pages/ResultsDemo';
import ErrorBoundary from './components/ErrorBoundary';

// Ensure httpOnly session cookies flow with every request (user + admin sessions).
axios.defaults.withCredentials = true;

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/upload" element={<UploadFlow />} />
          <Route path="/dashboard/:userId" element={<Dashboard />} />
          <Route path="/axp-console-k7m2x9" element={<AdminDashboard />} />
          <Route path="/results-demo" element={<ResultsDemo />} />
        </Routes>
      </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
